import { defineComponent, onMounted, onUnmounted } from 'vue';
import UnsafeExitModalCode from '@/presentation/components/shared/unsafe-exit-modal/unsafe-exit-modal.code';

export default defineComponent({
	setup: () => {
		const code = new UnsafeExitModalCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			modalContent: code.modalContent,
			loadingButton: code.loadingButton,
			saveInProgress: code.saveInProgress,
			isSaveEnabled: code.isSaveEnabled,
			closeModal: code.closeModal.bind(code),
			saveAndNavigate: code.saveAndNavigate.bind(code),
			revertAndNavigate: code.revertAndNavigate.bind(code)
		};
	}
});
